import { authService } from "../../services/auth.service";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { AppRoutes } from "../../constants/routes";
import { getEnvLabel } from "../../util/envLabel";
import { useAuthUserContext } from "../../context/AdministratorContextProvider";
import {
  Avatar,
  AvatarSizeVariant,
  // SettingsButton,
  Typography,
  TypographyVariant,
} from "../ui-kit";
import { MenuItem } from "../ui-kit/avatar/Menu";
import { AnimateAppearanceWrapper } from "../animate-appearence/AnimateAppearanceWrapper";
import { TableViewToggle } from "./TableViewToggle";

const Wrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100vw - 16px * 2);
  z-index: 2;
  display: flex;
  align-items: center;
  height: 36px;
  background: #ffffff;
  box-shadow: 0 1px 8px rgba(108, 108, 138, 0.08);
  padding: 10px 16px;
`;

// const SearchBox = styled.div`
//   margin-left: 173px;
// `;

const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto;
`;

const ProfileWrapper = styled.div`
  display: flex;
`;

// const StyledSettings = styled(SettingsButton)`
//   margin-right: 10px;
// `;

const SignUpButtons = styled.div`
  display: flex;
`;

const SignInButton = styled(Typography)`
  margin-right: 15px;
  cursor: pointer;
`;

// Per-env badge palette. Keep these distinct enough that an operator
// glancing at the header in two side-by-side tabs can immediately tell
// which environment they're poking at — confusing prod for stage (or
// qa for dev) is exactly the class of mistake this badge is here to
// prevent. Anything unrecognised falls through to the indigo "dev"
// look so a typo in REACT_APP_ENV doesn't silently render as prod.
const ENV_PALETTE: Record<string, { color: string; bg: string }> = {
  prod: { color: "#dc2626", bg: "rgba(220,38,38,0.08)" }, // red
  stage: { color: "#d97706", bg: "rgba(217,119,6,0.08)" }, // amber
  qa: { color: "#059669", bg: "rgba(5,150,105,0.08)" }, // green
  dev: { color: "#4f46e5", bg: "rgba(79,70,229,0.08)" }, // indigo
  local: { color: "#6b7280", bg: "rgba(107,114,128,0.08)" }, // grey
};

const getEnvPalette = (env: string) => ENV_PALETTE[env] ?? ENV_PALETTE.dev;

const EnvBadge = styled.div<{ $env: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 8px;
  padding: 3px 10px;
  border-radius: 4px;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: ${(p) => getEnvPalette(p.$env).color};
  background: ${(p) => getEnvPalette(p.$env).bg};
`;

const HeaderTitle = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #13273f;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const HeaderTitleText = styled.span`
  @media (max-width: 480px) {
    display: none;
  }
`;

interface HeaderProps {
  landing?: boolean;
  menuToggle?: React.ReactNode;
}

const Header: React.FunctionComponent<HeaderProps> = ({
  landing,
  menuToggle,
}) => {
  const navigate = useNavigate();
  const { clearAuthUser: clearUser } = useAuthUserContext();
  // const settingsNavigate = () => {
  //   navigate(AppRoutes.Private.Settings.BUSINESS_ACCOUNT);
  // };

  const handleLogOut = async () => {
    await authService.signOut();
    clearUser();
    navigate(AppRoutes.Open.Auth.SIGN_IN_START);
  };

  const goToSignIn = () => {
    navigate(AppRoutes.Open.Auth.SIGN_IN_START);
  };

  // const goToSignUp = () => {
  //   navigate(AppRoutes.Open.Auth.SIGN_UP_START);
  // };

  // const goToDashboard = () => {
  //   navigate(AppRoutes.Private.Dashboard.DASHBOARD_MAIN);
  // };

  return (
    <AnimateAppearanceWrapper>
      <Wrapper>
        {menuToggle}
        <HeaderTitle>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          <HeaderTitleText>Toolkit Admin</HeaderTitleText>
          <EnvBadge $env={process.env?.REACT_APP_ENV || "dev"}>
            <svg width="6" height="6" viewBox="0 0 6 6" fill="currentColor">
              <circle cx="3" cy="3" r="3" />
            </svg>
            {getEnvLabel()}
          </EnvBadge>
        </HeaderTitle>
        {/* <SearchBox> */}
        {/* <Search */}
        {/*  onChangeHandler={() => { */}
        {/*    console.warn(""); */}
        {/*  }} */}
        {/* /> */}
        {/* </SearchBox> */}
        <RightContainer>
          {landing ? (
            <SignUpButtons>
              <SignInButton
                onClick={goToSignIn}
                variant={TypographyVariant.BODY1}
              >
                Login
              </SignInButton>
              {/* <SignUpButton
              onClick={goToSignUp}
              variant={TypographyVariant.BODY1}
            >
              Sign up
            </SignUpButton> */}
            </SignUpButtons>
          ) : (
            <>
              <TableViewToggle />
              <ProfileWrapper>
                {/* <StyledSettings onClick={settingsNavigate} /> */}
                <Avatar
                  size={AvatarSizeVariant.SMALL}
                  avatarSrc={
                    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsEC-AcpMSEBeqwQdUVhjb5fciR-GG2-cuwQ&usqp=CAU"
                  }
                  isOnline
                >
                  <MenuItem
                    onClick={() =>
                      navigate(AppRoutes.Private.Profile.PROFILE_SETTINGS)
                    }
                  >
                    Profile Settings
                  </MenuItem>
                  <MenuItem onClick={handleLogOut}>Log out</MenuItem>
                </Avatar>
              </ProfileWrapper>
            </>
          )}
        </RightContainer>
      </Wrapper>
    </AnimateAppearanceWrapper>
  );
};

export default Header;
